import React, { useId } from "react";

/** Preserve the rendered ground shadow while the matte restores foreground colors. */
export function AuthIllustration() {
  const id = useId();
  const maskId = `${id}-mask`;
  const matteFilterId = `${id}-matte`;

  return (
    <div className="relative w-full max-w-[520px]" aria-hidden="true">
      {/* White disappears into the panel; the generated contact shadow remains. */}
      <img
        src="/login-form.webp"
        alt=""
        width={1254}
        height={1254}
        className="block h-auto w-full mix-blend-multiply"
      />
      <svg
        viewBox="0 0 1254 1254"
        width="1254"
        height="1254"
        className="absolute inset-0 h-full w-full"
        focusable="false"
      >
        <defs>
          <filter id={matteFilterId} colorInterpolationFilters="sRGB">
            {/* Inset the matte slightly to avoid a white fringe at the silhouette. */}
            <feMorphology operator="erode" radius="3" />
            <feComponentTransfer>
              <feFuncR type="linear" slope="1.12" intercept="-0.06" />
              <feFuncG type="linear" slope="1.12" intercept="-0.06" />
              <feFuncB type="linear" slope="1.12" intercept="-0.06" />
            </feComponentTransfer>
          </filter>
          <mask id={maskId} maskUnits="userSpaceOnUse" x="0" y="0" width="1254" height="1254">
            <image
              href="/illustrations/login-mask.webp"
              width="1254"
              height="1254"
              filter={`url(#${matteFilterId})`}
            />
          </mask>
        </defs>
        <image href="/login-form.webp" width="1254" height="1254" mask={`url(#${maskId})`} />
      </svg>
    </div>
  );
}
